import { render, staticRenderFns } from "./CounterpartTypePill.vue?vue&type=template&id=da57853e&scoped=true"
import script from "./CounterpartTypePill.vue?vue&type=script&lang=js"
export * from "./CounterpartTypePill.vue?vue&type=script&lang=js"
import style0 from "./CounterpartTypePill.vue?vue&type=style&index=0&id=da57853e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da57853e",
  null
  
)

export default component.exports